import { useState } from 'react';

type HTMLInputEvt = React.ChangeEvent<HTMLInputElement>;

export const useForm = <T extends object>(initialValues: T): [
  T,
  (event: HTMLInputEvt) => void,
  (obj: Partial<T>) => void
] => {
  const [values, setValues] = useState<T>(initialValues);

  const handleChange = (event: HTMLInputEvt) => {
    const { name, type, checked, value } = event.target;
    const nextValue: unknown = type === 'checkbox' ? checked : value;

    if (name.indexOf('.') > 0) {
      const [rawKey, subKey] = name.split('.') as [string, string];

      setValues(prev => {
        if (!(rawKey in prev)) return prev;

        const key = rawKey as keyof T;
        const parent = prev[key];

        if (typeof parent !== 'object' || parent === null) return prev;

        // Puente a unknown antes de Record<string, unknown>
        const parentObj = (parent as unknown) as { [k: string]: unknown };

        const updatedParent = {
          ...parentObj,
          [subKey]: nextValue,
        } as { [k: string]: unknown };

        // Puente a unknown antes de volver a T
        return ({
          ...(prev as unknown as { [k: string]: unknown }),
          [rawKey]: updatedParent,
        } as unknown) as T;
      });
    } else {
      setValues(prev => {
        if (!(name in prev)) return prev;
        const k = name as keyof T;
        return { ...prev, [k]: nextValue as T[typeof k] };
      });
    }
  };

  const externalSetValues = (obj: Partial<T>) => {
    setValues(prev => ({ ...prev, ...obj }));
  };

  return [values, handleChange, externalSetValues];
};
